import React from 'react';

import { getResourcePath, trans } from '@spotahome/soyuz/client';

import FAQSection from '@common/components/FAQSection';

import HeaderContainer from '../../../common/components/HeaderContainer';
import Footer from '../../../common/components/Footer';
import SessionExpiredModal from '../../../common/components/SessionExpiredModal';
import Cookies from '../../../common/components/Cookies';
import AppBanner from '../../../common/components/AppBanner';

import ContactUs from './ContactUs';

import './ContactUsRevamp.scss';

const ContactUsRevamp = () => (
  <div className="contact-us-revamp">
    <div className="contact-us-revamp__hero">
      <HeaderContainer color="dark" />
      <div className="contact-us-revamp__wrapper">
        <div className="contact-us-revamp__form">
          <div className="contact-us-revamp__header">
            <h1 className="contact-us-revamp__header-title">
              {trans('contact-us.header.title')}
            </h1>
            <p className="contact-us-revamp__header-subtitle">
              {trans('contact-us.header.subtitle')}
            </p>
          </div>
          <ContactUs />
        </div>
        <img
          src={getResourcePath('/images/contact-us/contact-form-intro.svg')}
          alt="contact form"
          className="contact-us-revamp__image"
        />
      </div>
    </div>
    <div className="contact-us-revamp__faq">
      <FAQSection />
    </div>
    <Footer />
    <SessionExpiredModal />
    <Cookies />
    <AppBanner />
  </div>
);

export default ContactUsRevamp;
